import { useRive } from "@rive-app/react-canvas";
import { ComponentProps, useMemo } from "react";

type RiveWrapperProps = ComponentProps<"canvas"> & {
  src: string;
  width?: number;
  height?: number;
  className?: string;
  thumbnail?: string;
};

// https://help.rive.app/runtimes/overview/react/parameters-and-return-values
export const RiveWrapper = ({ src, width, height, className = "", thumbnail, ...rest }: RiveWrapperProps) => {
  const { RiveComponent } = useRive(
    {
      src,
      stateMachines: "State Machine 1",
      autoplay: true
    },
    {
      useDevicePixelRatio: true,
      customDevicePixelRatio: 1
    }
  );

  const style = useMemo(() => {
    return {
      ...(width ? { width: `${width}px` } : {}),
      ...(height ? { height: `${height}px` } : {})
    };
  }, [width, height]);

  return (
    <>
      <img
        src={thumbnail}
        className={className}
        style={{
          ...style,
          objectFit: 'contain',
          width: `${width}px`,
          height: `${height}px`,
        }} />
      <RiveComponent width={width} height={height} style={{
        ...style,
      }} className={className} {...rest} />
    </>
  );
};
